import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Linkedin, Instagram, Twitter } from 'lucide-react';
import { legalDisclaimer, DEFAULT_LOGO } from '../siteContent';
import { useSiteContent } from '../context/SiteContentContext';

const columns = [
  {
    heading: 'Community',
    links: [
      { name: 'Join Free Community', path: '/membership' },
      { name: 'Volunteer', path: '/membership' },
      { name: 'Events', path: '/events' },
      { name: 'Corporate Life Series', path: '/corporate-life-series' }
    ]
  },
  {
    heading: 'Explore',
    links: [
      { name: 'How We Help', path: '/how-we-help' },
      { name: 'Knowledge Hub', path: '/knowledge-hub' },
      { name: 'About', path: '/about' },
      { name: 'Contact', path: '/contact' }
    ]
  },
  {
    heading: 'Support',
    links: [
      { name: 'Contact', path: '/contact' },
      { name: 'Privacy', path: '/privacy' },
      { name: 'Terms', path: '/terms' },
      { name: 'Login', path: '/login' }
    ]
  }
];

const Footer = () => {
  const year = new Date().getFullYear();
  const { home } = useSiteContent();
  const logo = home?.logo || DEFAULT_LOGO;
  return (
    <footer className="bg-[#003366] text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <img
              src={logo}
              alt="Equaltoo Foundation"
              className="h-12 w-auto mb-5 brightness-0 invert"
              loading="lazy"
              decoding="async"
            />
            <p className="text-white/70 text-sm leading-relaxed max-w-sm">
              India's first non-profit support ecosystem for corporate professionals — community, peer learning, legal awareness, career transition and wellbeing.
            </p>
            <div className="flex gap-3 mt-6">
              {[Linkedin, Twitter, Instagram].map((Icon, i) => (
                <a key={i} href="#" className="bg-white/10 hover:bg-[#E74C3C] p-2.5 rounded-full transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.heading}>
              <h4 className="font-heading text-sm uppercase tracking-[0.2em] text-white/50 mb-4">{col.heading}</h4>
              <ul className="space-y-3 text-sm">
                {col.links.map((l) => (
                  <li key={l.name}>
                    <Link to={l.path} className="text-white/80 hover:text-white transition-colors">{l.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-white/10">
          <p className="text-xs text-white/50 leading-relaxed max-w-4xl">
            <span className="font-semibold text-white/70">Legal Disclaimer: </span>{legalDisclaimer}
          </p>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 mt-8">
            <p className="text-sm text-white/60">© {year} Equaltoo Foundation · Section 8 Non-Profit · NGO Darpan | 12A | 80G</p>
            <div className="flex gap-5 text-sm text-white/70">
              <a href="tel:7206689787" className="flex items-center gap-2 hover:text-white"><Phone className="w-4 h-4" />7206689787</a>
              <a href="mailto:support@equaltoo.org.in" className="flex items-center gap-2 hover:text-white"><Mail className="w-4 h-4" />Email us</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
